<template>
  <Modal
    v-model="_value"
    width="500"
    title="批量发送短信"
    @on-visible-change="visibleChange"
    ok-text="关闭"
    cancel-text="">
    <Form ref="setDriverCardParamsRef" v-model="setDriverCardParams" :label-width="80">
      <FormItem prop="driverCardNum" label="短信内容">
        <Input type="textarea" v-model="shortmessage.message" placeholder="请输入短信内容">
        </Input>
      </FormItem>
      <FormItem prop="driverLicenseNum" label="SIM卡号">
        <Input type="textarea" :rows="6" v-model="simNums" placeholder="SIM卡号列表，使用','分隔">
        </Input>
      </FormItem>
      <Button type="primary" @click="onCleanDriverCardParams" style="margin-right: 5px;">清空</Button>
      <Button type="primary" @click="onSendDriverCardParams">发送</Button>
    </Form>
  </Modal>
</template>

<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

export default {
  name: 'batchsetmessagesmodal',
  components: {

  },
  props: {
    initValue: null,
    terminalNumValue: null,
    value: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
        simNums: null,
      shortmessage: {
        id: null,
        message: null,
        simNums: null,
      }

    }
  },
  methods: {
    ...mapActions([
      'VehicleInfoServ_SearchByName'
    ]),
    visibleChange (val) {
      if (val) {
        this.shortmessage.id = this._initValue
        this.shortmessage.message = null
        this.shortmessage.simNums = null
      }
    },
    onCleanDriverCardParams () {
      this.shortmessage.message = null
      this.shortmessage.simNums = null
    },
    onSendDriverCardParams () {
      if (!this.simNums || this.simNums === '') {
        this.$Message.error('SIM号不能为空')
        return
      }
      if (!this.shortmessage.message || this.shortmessage.message === '') {
        this.$Message.error('短信内容不能为空')
        return
      }
      this.shortmessage.simNums = this.simNums.replace(/\n/g,"").split(',')
      store.dispatch('ShortMessageServ_BatchSendMessage', {
        params: {
          simNums:this.shortmessage.simNums,
          message:this.shortmessage.message,
        }
      }).then(res => {
        this.$Message.success('发送成功')
        this.$emit('on-success',this.shortmessage.simNums)
        this.$Message.success(res.msg)
      }).catch(err => {
        this.$Message.error(err)
      })
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    },
    _terminalNumValue: {
      get () {
        return this.terminalNumValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
